import React, { useState } from 'react';
import { ToolPen, ToolReactangleIcon, ToolPolygonIcon, ToolDebug, ToolMagnifier, ToolFilter, ToolDelete, ToolSave, ToolCamera, downloadIconBlack, Stack } from '../../ui/assets/svgIcons/icon'
import { _roleType } from '@custom/Utils/constants/appConstants';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@custom/store/store';
import uploadImageMicroscopy from '@custom/rtk-apis/microscopy';
import { Loader, SuccessModal } from '@ohif/ui';
import { servicesManager } from '../../app/src/App';


const Control = ({
  filters,
  setFilters,
  getMicroscopyLink,
  enableRectangleMode,
  enablePolygonMode,
  toggleMode,
  toggleFilter,
  toggleMagnifier,
  toggleDebug,
  saveMeasurements,
  currentReport,
  handleViewReport,
  setIsOpen,
  isOpen,
  selectedTemplate,
  search,
  setSearch,
  filteredTemplates,
  handleSlelectTemplate,
  userAnnotating,
  saveImage,
  clickedAnnotation,
  handleDeleteAnnotation,
  downloadImage,
  tileSources,
  currentPage,
  AddToSeries,
  onViewAIResults,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const role = sessionStorage.getItem('role') || localStorage.getItem('role');
  const { uiNotificationService } = servicesManager.services;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [successModal, setSuccessModal] = useState({
    message: "",
    isOpen: false
  });
  const isVideo = tileSources?.length > 0 && tileSources[currentPage]?.endsWith('.mp4');
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleUploadSeries = async () => {
    const urlParts = window.location.href.split("/");
    const uhid = urlParts[urlParts.length - 2];
    const wsiId = urlParts[urlParts.length - 1];

    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".jpg, .jpeg, .png, .svs, .mp4";
    input.onchange = async (event) => {
      const file = event.target.files[0];

      if (!file) {
        console.log("No file selected");
        return;
      }

      const formData = new FormData();
      formData.append("uhid", uhid);
      formData.append("wsiId", wsiId);
      formData.append("file", file);

      try {
        setIsLoading(true);
        const response = await dispatch(uploadImageMicroscopy(formData));
        setIsLoading(false);
        if (response?.payload?.status == "SUCCESS") {
          setSuccessModal({ isOpen: true, message: response?.payload?.msg || "Successfully uploaded.." });
          setTimeout(() => {
            getMicroscopyLink();
          }, 1000);
        } else if (response?.payload?.status === "ERROR") {
          uiNotificationService.show({
            title: 'Something went wrong.',
            message: response?.payload?.msg || "Something went wrong while uploading...",
            type: 'error',
            duration: 2000
          });
        }
      } catch (error) {
        console.error("Upload failed:", error);
        uiNotificationService.show({
          title: 'Something went wrong.',
          message: error?.msg || "Something went wrong while uploading...",
          type: 'error',
          duration: 2000
        });
        setIsLoading(false);
      }
    };
    input.click();
  }
  return (

    <div className="controls" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', margin: "1rem" }}>
      <div className='flex flex-row justify-between items-center pr-1' >
        {!isVideo && (
          <div className='flex-wrap' style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>


          <button className={`btn ${filters?.rectangleEnable ? 'btn__white__on' : 'btn__white'}`} onClick={enableRectangleMode} disabled={!filters?.drawingEnabled} title='Rectangle'>
            <img className='w-[30px]' src={ToolReactangleIcon} alt="Reactangle" />
          </button>
          <button className={`btn ${filters?.rectangleEnable ? 'btn__white' : 'btn__white__on'}`} onClick={enablePolygonMode} disabled={!filters?.drawingEnabled} title='Polygon'><img className='w-[30px]' src={ToolPolygonIcon} alt="Polygon" />
          </button>
          <button className={`btn ${filters?.debug ? 'btn__white__on' : 'btn__white'}`} onClick={toggleDebug} title='Debug'><img className='w-[30px]' src={ToolDebug} alt="Debug" /></button>
          <button className={`btn ${filters?.drawingEnabled ? 'btn__white__on' : 'btn__white'}`} onClick={toggleMode} title={filters?.drawingEnabled ? 'Disable annotation mode' : 'Enable annotation mode'}
          >
            <img className='w-[30px]' src={ToolPen} alt="Annotate" />
          </button>
          <button className={`btn ${filters?.magnifierEnable ? 'btn__white__on' : 'btn__white'}`} onClick={toggleMagnifier} title='Magnifier'>
            <img className='w-[30px]' src={ToolMagnifier} alt="Magnifier" />
          </button>

          {/* Filters Button with Dropdown */}
          <div style={{ position: 'relative' }}>
            <div className='flex flex-row gap-4'>
              <button
                className={`btn ${isDropdownOpen ? 'btn__white__on' : 'btn__white'}`}
                onClick={toggleDropdown}
                style={{
                  position: 'relative',
                  padding: '8px 16px',
                  cursor: 'pointer',
                }}
                title='Filter'
              >
                <img className='w-[30px]' src={ToolFilter} alt="Filter" />
              </button>
              <button className="btn btn__white" onClick={saveImage} title='Attach to Report'>
                <img className='w-[30px]' src={ToolCamera} alt="icon" />
              </button>
              <button className="btn btn__white" onClick={downloadImage} title='Download'>
                <img className='w-[30px]' src={downloadIconBlack} alt="icon" />
              </button>
              { userAnnotating &&
                <button className="btn btn__white" onClick={saveMeasurements} title='Save Annotation'>
                  <img className='w-[30px]' src={ToolSave} alt="Save Annotation" />
                </button>
              }
            </div>
            {isDropdownOpen && (
              <div
                className="dropdown-content"
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  padding: '1rem',
                  borderRadius: '4px',
                  zIndex: 1000, // High z-index to stay above other elements
                  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                  maxHeight: '300px',
                  overflowY: 'auto',
                  minWidth: '350px',
                }}
              >
                {/* Filter Controls */}
                <div className="panel">
                  <div style={{ display: "flex", columnGap: "15px", alignItems: "center" }}>
                    <label style={{ display: "flex", marginTop: "0px", columnGap: "5px" }}>
                      <input
                        type="checkbox"
                        checked={filters?.selectedFilters.includes("brightness")}
                        onChange={() => toggleFilter("brightness")}
                      />
                      Brightness
                    </label>
                    <input
                      style={{ WebkitAppearance: "progress-bar" }}
                      type="range"
                      min={-255}
                      max={255}
                      step={1}
                      value={filters?.brightnessValue}
                      onChange={(e) => setFilters(prev => ({ ...prev, brightnessValue: Number(e.target.value) }))}
                      disabled={!filters?.selectedFilters.includes("brightness")}
                    />
                    <span>{filters?.brightnessValue}</span>
                  </div>
                  <div style={{ display: "flex", columnGap: "15px", alignItems: "center" }}>
                    <label style={{ display: "flex", marginTop: "0px", columnGap: "5px" }}>
                      <input
                        type="checkbox"
                        checked={filters?.selectedFilters.includes("contrast")}
                        onChange={() => toggleFilter("contrast")}
                      />
                      Contrast
                    </label>
                    <input
                      style={{ WebkitAppearance: "progress-bar" }}
                      type="range"
                      min={0}
                      max={2}
                      step={0.01}
                      value={filters?.contrastValue}
                      onChange={(e) => setFilters(prev => ({ ...prev, contrastValue: Number(e.target.value) }))}
                      disabled={!filters?.selectedFilters.includes("contrast")}
                    />
                    <span>{filters?.contrastValue.toFixed(2)}</span>
                  </div>


                  <div style={{ display: "flex", columnGap: "15px", alignItems: "center" }}>
                    <label style={{ display: "flex", marginTop: "0px", columnGap: "5px" }}>
                      <input
                        type="checkbox"
                        checked={filters?.selectedFilters.includes("threshold")}
                        onChange={() => toggleFilter("threshold")}
                      />
                      Threshold
                    </label>
                    <input
                      style={{ WebkitAppearance: "progress-bar" }}
                      type="range"
                      min={0}
                      max={255}
                      step={1}
                      value={filters?.thresholdValue}
                      onChange={(e) => setFilters(prev => ({ ...prev, thresholdValue: Number(e.target.value) }))}
                      disabled={!filters?.selectedFilters.includes("threshold")}
                    />
                    <span>{filters?.thresholdValue}</span>
                  </div>

                  <div style={{ display: "flex", columnGap: "15px", alignItems: "center" }}>
                    {/* Gamma Control */}
                    <label style={{ display: "flex", marginTop: "0px", columnGap: "5px" }}>
                      <input
                        type="checkbox"
                        checked={filters?.selectedFilters.includes("gamma")}
                        onChange={() => toggleFilter("gamma")}
                      />
                      Gamma
                    </label>
                    <input
                      style={{ WebkitAppearance: "progress-bar" }}
                      type="range"
                      min={0.1}
                      max={3}
                      step={0.1}
                      value={filters?.gammaValue}
                      onChange={(e) => setFilters(prev => ({ ...prev, gammaValue: Number(e.target.value) }))}
                      disabled={!filters?.selectedFilters.includes("gamma")}
                    />
                    <span>{filters?.gammaValue.toFixed(1)}</span>
                  </div>



                  <div style={{ display: "flex", columnGap: "15px", alignItems: "center" }}>
                    {/* Erosion Control */}
                    <label style={{ display: "flex", marginTop: "0px", columnGap: "5px" }}>
                      <input
                        type="checkbox"
                        checked={filters?.selectedFilters.includes("erosion")}
                        onChange={() => toggleFilter("erosion")}
                      />
                      Erosion
                    </label>
                    <input
                      style={{ WebkitAppearance: "progress-bar" }}
                      type="range"
                      min={3}
                      max={9}
                      step={2}
                      value={filters?.erosionValue}
                      onChange={(e) => setFilters(prev => ({ ...prev, erosionValue: Number(e.target.value) }))}
                      disabled={!filters?.selectedFilters.includes("erosion")}
                    />
                    <span>{filters?.erosionValue}</span>
                  </div>

                  <div style={{ display: "flex", columnGap: "15px", alignItems: "center" }}>
                    {/* Dilation Control */}
                    <label style={{ display: "flex", marginTop: "0px", columnGap: "5px" }}>
                      <input
                        type="checkbox"
                        checked={filters?.selectedFilters.includes("dilation")}
                        onChange={() => toggleFilter("dilation")}
                      />
                      Dilation
                    </label>
                    <input
                      style={{ WebkitAppearance: "progress-bar" }}
                      type="range"
                      min={3}
                      max={9}
                      step={2}
                      value={filters?.dilationValue}
                      onChange={(e) => setFilters(prev => ({ ...prev, dilationValue: Number(e.target.value) }))}
                      disabled={!filters?.selectedFilters.includes("dilation")}
                    />
                    <span>{filters?.dilationValue}</span>
                  </div>

                  <div style={{ display: "flex", columnGap: "15px", alignItems: "center" }}>
                    <label style={{ display: "flex", columnGap: "5px" }}>
                      <input
                        type="checkbox"
                        checked={filters?.selectedFilters.includes("greyscale")}
                        onChange={() => toggleFilter("greyscale")}
                      />
                      Greyscale
                    </label>
                  </div>
                  <div>

                    <label style={{ display: "flex", columnGap: "5px" }}>
                      <input
                        type="checkbox"
                        checked={filters?.selectedFilters.includes("invert")}
                        onChange={() => toggleFilter("invert")}
                      />
                      Invert
                    </label>
                  </div>

                  <div style={{ display: "flex", columnGap: "15px", alignItems: "center" }}>
                    <label style={{ display: "flex", columnGap: "5px" }}>
                      <input
                        type="checkbox"
                        checked={filters?.selectedFilters.includes("sharpen")}
                        onChange={() => toggleFilter("sharpen")}
                      />
                      Sharpen
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div>
            {clickedAnnotation && <button className='btn btn__white' onClick={handleDeleteAnnotation} title='Delete Annotation'><img className='w-[30px]' src={ToolDelete} alt="Delete" /></button>}
          </div>
        </div>
        )}
        {
          isVideo && (
            <button className="btn btn__white" onClick={AddToSeries} title="Add to Series">
              <img className='w-[30px]' src={Stack} alt="icon" />
          </button>
          )
        }
        <div style={{ color: "white", fontSize: "16px", background: "rgba(0,0,0,0.5)", padding: "5px", borderRadius: "5px" }}>
          {currentPage + 1} / {tileSources?.length}
        </div>
        <div className='flex gap-4'>
          {onViewAIResults && (
            <button className="btn btn__white" onClick={onViewAIResults} title="View AI Results">
              AI Results
            </button>
          )}
          {role == _roleType.technician && <button onClick={handleUploadSeries}>Upload Series</button>}
          {(role == _roleType.pathologist || role == _roleType.superAdmin) &&
            (currentReport.length != 0 ?
              <button className='btn btn__white__on' onClick={() => handleViewReport(currentReport)}>View Report</button>
              :
            <div>
                <button className="btn btn__white" onClick={() => setIsOpen(!isOpen)}>
                  {selectedTemplate?.templateName || "Generate Report"}
                </button>
                {isOpen && (
                  <div
                    style={{
                      position: "absolute",
                      width: "10rem",
                      border: "1px solid #ccc",
                      borderRadius: '5px',
                      background: "#fff",
                      zIndex: 1000,
                    }}
                  >
                    <input
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Search..."
                      style={{ width: "100%", padding: "10px", boxSizing: "border-box" }}
                    />
                    {filteredTemplates.map((template, i) => (
                      <div
                        key={template._id}
                        onClick={() => handleSlelectTemplate(template)}
                        style={{ padding: "10px", cursor: "pointer" }}
                      >
                        {template.templateName}
                      </div>
                    ))}
                    {filteredTemplates.length === 0 && (
                      <div style={{ padding: "10px", textAlign: "center" }}>
                        No templates found
                      </div>
                    )}
                  </div>
                )}
              </div>
            )
          }
          {role == _roleType.technician && currentReport?.length != 0 &&
            <button className='btn btn__white__on' onClick={() => handleViewReport(currentReport)}>View Report</button>
          }
        </div>
      </div>
      <Loader isLoaderOpen={isLoading} />
      <SuccessModal
        isSuccessModalOpen={successModal?.isOpen}
        title={successModal?.message}
        handleCloseModal={() => {
          setTimeout(() => {
            setSuccessModal({ isOpen: false, message: "" })
          }, 2000);
        }}
      />
    </div>
  )
}

export default Control
